// tslint:disable
/**
 * CourseDocumentInfo API
 * Used for: - Manage course document info 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CourseDocumentInfo } from '../models';
import { CourseDocumentInfoEdit } from '../models';
/**
 * CourseDocumentInfoApi - axios parameter creator
 * @export
 */
export const CourseDocumentInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourseDocumentInfo(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCourseDocumentInfo.');
            }
            const localVarPath = `/course-document-info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CourseDocumentInfoEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCourseDocumentInfo(id: string, body: CourseDocumentInfoEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCourseDocumentInfo.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editCourseDocumentInfo.');
            }
            const localVarPath = `/course-document-info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseDocumentInfo(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCourseDocumentInfo.');
            }
            const localVarPath = `/course-document-info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseDocumentInfoApi - functional programming interface
 * @export
 */
export const CourseDocumentInfoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourseDocumentInfo(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CourseDocumentInfoApiAxiosParamCreator(configuration).deleteCourseDocumentInfo(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CourseDocumentInfoEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCourseDocumentInfo(id: string, body: CourseDocumentInfoEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseDocumentInfo> {
            const localVarAxiosArgs = CourseDocumentInfoApiAxiosParamCreator(configuration).editCourseDocumentInfo(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseDocumentInfo(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseDocumentInfo> {
            const localVarAxiosArgs = CourseDocumentInfoApiAxiosParamCreator(configuration).getCourseDocumentInfo(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CourseDocumentInfoApi - factory interface
 * @export
 */
export const CourseDocumentInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourseDocumentInfo(id: string, options?: any) {
            return CourseDocumentInfoApiFp(configuration).deleteCourseDocumentInfo(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CourseDocumentInfoEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCourseDocumentInfo(id: string, body: CourseDocumentInfoEdit, options?: any) {
            return CourseDocumentInfoApiFp(configuration).editCourseDocumentInfo(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseDocumentInfo(id: string, options?: any) {
            return CourseDocumentInfoApiFp(configuration).getCourseDocumentInfo(id, options)(axios, basePath);
        },
    };
};

/**
 * CourseDocumentInfoApi - object-oriented interface
 * @export
 * @class CourseDocumentInfoApi
 * @extends {BaseAPI}
 */
export class CourseDocumentInfoApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseDocumentInfoApi
     */
    public deleteCourseDocumentInfo(id: string, options?: any) {
        return CourseDocumentInfoApiFp(this.configuration).deleteCourseDocumentInfo(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {CourseDocumentInfoEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseDocumentInfoApi
     */
    public editCourseDocumentInfo(id: string, body: CourseDocumentInfoEdit, options?: any) {
        return CourseDocumentInfoApiFp(this.configuration).editCourseDocumentInfo(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseDocumentInfoApi
     */
    public getCourseDocumentInfo(id: string, options?: any) {
        return CourseDocumentInfoApiFp(this.configuration).getCourseDocumentInfo(id, options)(this.axios, this.basePath);
    }

}
